import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AppUserMenu, AppUserMenuItem, MenuDisplayMode } from '../models/app.user.menu';
import { TimelineService } from './timeline.service';
import { ExternalLinkService } from './external-link.service';
import { WaitingDialogComponent } from '../../timeline/lessons/dialogs/dialog.waiting.component';

@Injectable({ providedIn: 'root' })
export class MenuActionService {

  private ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'lg',
    container: 'nb-layout'
  };

  constructor(
    private timelineService: TimelineService,
    private router: Router,
    private modal: NgbModal,
    private externalLinkService: ExternalLinkService
  ) {}

  hasSingleItem(menu: AppUserMenu): boolean {
    return menu?.menuitems?.length === 1;
  }

  // Respeita o display_mode do backend; sem valor, mantém o comportamento atual (navbar).
  getDisplayMode(menu: AppUserMenu): MenuDisplayMode {
    return menu?.display_mode || 'navbar';
  }

  isHomeBlock(menu: AppUserMenu): boolean {
    return this.getDisplayMode(menu) === 'home_block';
  }

  async openOrPlay(model: AppUserMenuItem): Promise<void> {
    const actionButton = model?.action;
    if (!actionButton) return;
    const actionType: string = actionButton.type;

    if (actionButton.url?.includes('challenge')) {
      const activeModal: NgbModalRef = this.modal.open(WaitingDialogComponent, this.ngbModalOptions);
      const { title, desc } = await this.timelineService.getNotOpenInAppDefaultTexts('challenge');
      activeModal.componentInstance.waitingTitle = title;
      activeModal.componentInstance.waitingSubtitle = desc;
      activeModal.result.then((): void => { }, (): void => { });
      return;
    }

    this.modal.dismissAll();
    if (this.externalLinkService.isLinkType(actionType) && actionButton.url) {
      this.externalLinkService.openLink(actionButton.url, actionType, {
        legacyInApp: model.open_external == false,
        title: model.cta_caption,
      });
      return;

    } else if (actionType == 'INTERNAL_URL' && actionButton.url) {
      let actionUrl: string = actionButton.url;
      if (actionUrl.replace('timeline/', '') != actionUrl) {
        const brokenUrl: string[] = actionUrl.split('timeline/');
        this.router.navigate(['comunidade', 'postagem', brokenUrl[1]], { queryParams: { from: 'timeline' } });
      } else if (actionUrl.replace('live/', '') != actionUrl) {
        const brokenUrl: string[] = actionUrl.split('live/');
        this.router.navigate(['comunidade', 'postagem', 'live', brokenUrl[1]], { queryParams: { from: 'timeline' } });
      } else if (actionUrl.includes('lesson/')) {
        const brokenUrl: string[] = actionUrl.split('lesson/');
        const id: string[] = actionUrl.split('product/')[1].split('/');
        this.router.navigate(['produtos', id[0], 'aula', brokenUrl[1]], { queryParams: { from: 'timeline' } });
      } else if (actionUrl.includes('product/')) {
        const brokenUrl: string[] = actionUrl.split('product/');
        this.router.navigate(['produtos', `${brokenUrl[1]}`], { queryParams: { from: 'timeline' } });
      } else {
        this.router.navigate(['comunidade']);
      }
    } else if (actionType == 'REGISTER') this.router.navigate(['login']);

    else if (actionType == 'HTML' && actionButton.url) {
      const brokenUrl: string[] = actionButton.url.split('menuitem/');
      this.timelineService.menu$.next(model);
      this.router.navigate(['menuitem', `${brokenUrl[1]}`], { queryParams: { from: 'timeline' } });
      return;
    }
  }
}
